export default {
  CATEGORIES_UPDATED: (state, categories) => {
    state.categories = categories
  },

  CURRENT_CATEGORY_UPDATED: (state, category) => {
    state.currentCategory = category
  },

  CATEGORY_NEW_COURSES_UPDATED: (state, courses) => {
    state.currentCategoryNewCourses = courses
  },

  CATEGORY_POPULAR_COURSES_UPDATED: (state, courses) => {
    state.currentCategoryPopularCourses = courses
  },

  CATEGORY_LEARNING_PATHS_UPDATED: (state, paths) => {
    state.currentCategoryLearningPaths = paths
  },
}
